import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=d4b9e9da&scoped=true&"
import script from "./Seats.vue?vue&type=script&lang=js&"
export * from "./Seats.vue?vue&type=script&lang=js&"
import style0 from "./Seats.vue?vue&type=style&index=0&id=d4b9e9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9e9da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
